module.exports = __webpack_public_path__ + "static/media/profileIconDark.973578a7.svg";